module.exports = "<div class=\"sv-action-bar-separator\" data-bind=\"css: $data.css\"></div>";